import React, { useState } from "react";
import SuperAdminLoginModal from "@/components/SuperAdminLoginModal";

export default function SiteFooter() {
  const [showSuperAdmin, setShowSuperAdmin] = useState(false);
  return (
    <>
      <footer
        data-testid="site-footer"
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 40,
          background: "color-mix(in srgb, var(--v-bg) 92%, transparent)",
          backdropFilter: "blur(12px)",
          borderTop: "1px solid var(--v-border)",
          padding: "10px 0",
          fontSize: 11,
          letterSpacing: ".06em",
          color: "var(--v-text-2)",
        }}
      >
        <div
          className="v-container site-footer-inner"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="mono" data-testid="footer-copyright">
            © 2026 Therefore Design Pvt. Ltd. <span style={{ opacity: 0.5 }}>|</span> Verdict Packaging Audit
          </span>
          <span style={{ display: "inline-flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
            <a
              href="mailto:info@thereforedesign.co.in"
              data-testid="footer-email"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              info@thereforedesign.co.in
            </a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a
              href="https://www.thereforedesign.co.in"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              www.thereforedesign.co.in
            </a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a
              href="/pricing"
              data-testid="footer-pricing"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              Pricing
            </a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/about" data-testid="footer-about" style={{ color: "inherit", textDecoration: "none" }}>About</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/framework" data-testid="footer-framework" style={{ color: "inherit", textDecoration: "none" }}>Framework</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/faq" data-testid="footer-faq" style={{ color: "inherit", textDecoration: "none" }}>FAQ</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/support" data-testid="footer-support" style={{ color: "inherit", textDecoration: "none" }}>Support</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/terms" data-testid="footer-terms" style={{ color: "inherit", textDecoration: "none" }}>Terms</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/privacy" data-testid="footer-privacy" style={{ color: "inherit", textDecoration: "none" }}>Privacy</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <a href="/refund" data-testid="footer-refund" style={{ color: "inherit", textDecoration: "none" }}>Refund policy</a>
            <span style={{ opacity: 0.4 }}>|</span>
            <button
              type="button"
              onClick={() => setShowSuperAdmin(true)}
              data-testid="open-super-admin-btn"
              style={{
                background: "transparent",
                border: "1px solid var(--v-accent)",
                color: "var(--v-accent)",
                padding: "4px 12px",
                cursor: "pointer",
                fontSize: 11,
                letterSpacing: ".14em",
                textTransform: "uppercase",
                fontFamily: "inherit",
                fontWeight: 600,
                borderRadius: 999,
                lineHeight: 1.2,
                transition: "background .2s ease, color .2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--v-accent)";
                e.currentTarget.style.color = "#000";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "var(--v-accent)";
              }}
            >
              Super-admin login
            </button>
          </span>
        </div>
      </footer>
      <SuperAdminLoginModal open={showSuperAdmin} onClose={() => setShowSuperAdmin(false)} />
    </>
  );
}
